<template>
  <!-- <div class="head-main"> -->
  <!-- <img :src="headURL" class="headimg" /> -->
  <div :style="{'background-image':'url('+headURL+')'}" class="headImage"></div>
  <!-- </div> -->
</template>
<script>
import headUrl from "../../api/headurl";
import { mapMutations, mapState, mapGetters } from "vuex";
export default {
  props: ["itcode"],
  data() {
    return {
      headURL: "",
      src: "",
      title: "",
      url: require("../../assets/image/logo_icon.png")
    };
  },

  computed: {
    ...mapState(["headurl", "rong"]),
    ...mapGetters({ headSrc: "headurl/headSrc" })
  },
  methods: {
    ...mapMutations({ setUrl: "headurl/setUrl" })
  },
  mounted() {
    if (!this.itcode) return;
    // console.log(this.headurl.urlList, this.itcode, "111");
    if (this.headurl.urlList) {
      let ary = this.headurl.urlList.filter(item => {
        return item.itCode === this.itcode;
      });
      let obj = ary.length ? ary[0] : false;
      let src = obj.simageUri || obj.imageUri;
      this.headURL = this.headurl.beforeurl + src;
      this.title = obj.itCode;
      if (!obj) {
        headUrl.head_url(this.itcode).then(ary => {
          let val = ary ? (ary.length ? ary[0] : false) : false;
          // console.log(val)
          if (!val) return;
          // console.log(val)
          this.setUrl(val);
          let src = val.simageUri || val.imageUri;
          this.headURL = this.headurl.beforeurl + src;
          this.title = val.itCode;
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.headImage {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
// .head-main {
//   .headimg {
//     max-width: 32px;
//     max-height: 32px;
//   }
// }
</style>





// WEBPACK FOOTER //
// src/components/headurl/index.vue